import { css } from '@emotion/react'
import { colors, spacing, measures } from 'styles/variables'

const { unit } = measures

export const overlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(4)};
`

export const popup = css`
  background-color: ${colors.grays.gray8};
  border-radius: ${unit * 3}px;
  max-width: 300px;
  width: 100%;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
`

export const popupContent = css`
  padding: ${spacing(5, 5, 4, 5)};
  text-align: center;
`

export const title = css`
  color: ${colors.white100};
  margin: 0 0 ${spacing(3)} 0;
  font-weight: 600;
  font-size: 14px;
`

export const message = css`
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  line-height: 1.4;
  font-weight: 400;
  font-size: 12px;
`

export const spacer = css`
  height: ${spacing(2)};
`

export const buttonContainer = css`
  display: flex;
  gap: ${spacing(2.5)};
  justify-content: center;
  align-items: center;
`

export const button = css`
  flex: 0 0 auto;
  width: 100px;
  padding: ${spacing(1.5, 2)};
  border-radius: ${unit * 4}px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
`

export const noButton = css`
  background: transparent;
  border: 2px solid #48bb78;

  &:hover {
    background-color: rgba(72, 187, 120, 0.1);
    border-color: #38a169;
  }
`

export const yesButton = css`
  background-color: #48bb78;
  border: 2px solid #48bb78;

  &:hover {
    background-color: #38a169;
    border-color: #38a169;
  }
`

export const noButtonText = css`
  color: #48bb78;
  margin: 0;
  font-weight: 500;
  font-size: 12px;
`

export const yesButtonText = css`
  color: ${colors.black100};
  margin: 0;
  font-weight: 500;
  font-size: 12px;
` 